import { PartComponent } from "../../../../app/reference/models/part-component";
import { Estimate } from "./estimate";
import { EstimateType } from "./estimate-type";

export class PartEstimate extends Estimate {
    constructor() {
        super(EstimateType.Part);
    }

    public partComponent: PartComponent = new PartComponent("", "", "");
    public partNumber: string = "";
    public eta: number = 0;
    public price: number = 0.0;
    public quantity: number = 0;
    public taxPercentage: number = 0.0;
    public isOem: boolean = false;
    public description: string = "";
    public override get total(): number { return this.price * this.quantity; }
}